/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type UnitsThemeGroupsQueryVariables = {};
export type UnitsThemeGroupsQueryResponse = {
    readonly themeGroups: ReadonlyArray<{
        readonly id: string;
        readonly name: string;
        readonly themes: Record<string, any>;
    }>;
};
export type UnitsThemeGroupsQuery = {
    readonly response: UnitsThemeGroupsQueryResponse;
    readonly variables: UnitsThemeGroupsQueryVariables;
};



/*
query UnitsThemeGroupsQuery {
  themeGroups {
    id
    name
    themes
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "ThemeGroup",
    "kind": "LinkedField",
    "name": "themeGroups",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "themes",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "UnitsThemeGroupsQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "UnitsThemeGroupsQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "61fff8a4547ee5a28fd6ec7f7a453dc9",
    "id": null,
    "metadata": {},
    "name": "UnitsThemeGroupsQuery",
    "operationKind": "query",
    "text": "query UnitsThemeGroupsQuery {\n  themeGroups {\n    id\n    name\n    themes\n  }\n}\n"
  }
};
})();
(node as any).hash = '2477f00b0e4aca5f574834e0ec216129';
export default node;
